var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:`cardMenu cardMenu--${!_vm.showName ? 'center' : ''}`,attrs:{"to":_vm.menu.to}},[_c('iconic',{staticClass:"cardMenu__icon",attrs:{"name":_vm.menu.icon}}),(_vm.showName)?_c('span',{class:`cardMenu__name`},[_vm._v(_vm._s(_vm.menu.name))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }